import './App.css';
import React, { Component }  from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useEffect, useState} from "react";
import {useHistory, withRouter} from "react-router";
import AuthenticatedView from "./AuthenticatedView";
import NotAuthenticatedView from "./NotAuthenticatedView";
import {connect} from "react-redux";
import {logOutMe} from "./redux/authReducer";
import 'react-notifications-component/dist/theme.css'
import {compose} from "redux";
import {readFromStorage} from "./api/storageApi";
const name = readFromStorage('name')
const email = readFromStorage('email')
const isAuth = readFromStorage('isAuth')

let mapStateToProps = state => ({
    isAuth: state.authPage.isAuth,
    username:state.authPage.name,
    isLoadingStatus:state.authPage.isLoadingStatus
})
const App =({isAuth,logOutMe,...props}) => {
    let [isAuthed,setAuthed] =useState(isAuth);
    let history = useHistory();
    useEffect(()=>{
        if(isAuthed === false){
            // history.push("/");
        }
    },[])

    useEffect(()=>{
        console.log("Home :"+isAuthed)
        if(isAuthed === false){
            history.push("/Login/");
        }
    },[isAuthed])
  return (<>
          {isAuthed ?
              <AuthenticatedView logOutMe={logOutMe} {...props}/> :
              <NotAuthenticatedView/>
          }
        </>
  );
}

export default compose(
    withRouter,
    connect(mapStateToProps,{logOutMe})
)(App);

